module.exports = __webpack_public_path__ + "static/media/Halil Bolukbashi.a42d92d7.png";